import {
  useState
} from 'react';

import {
  usePostGroupQuestionsMutation
} from 'src/redux/openapi';
import {
  useGetQuestionSetsAllMutation,
  useGetQuestionsByQuestionSetIdAllMutation,
} from 'src/shared/api/groups/groupsApi';
import {
  successfulToast
} from 'src/shared/components';
import {
  showWarningFromServer
} from 'src/shared/utils';

export const useToggleSetStatus = (groupId: string) => {
  const [loadingSetId, setLoadingSetId] = useState<string | null>(null);

  const [getQuestionSetsAll] = useGetQuestionSetsAllMutation();
  const [getQuestionsBySetIdAll] = useGetQuestionsByQuestionSetIdAllMutation();
  const [postGroupQuestions] = usePostGroupQuestionsMutation();

  const toggle = async (
    questionSetId: string,
    currentGroupStatus: 'ACTIVATED' | 'DEACTIVATED' | null,
  ) => {
    if (!groupId) {
      return;
    }

    setLoadingSetId(questionSetId);

    try {
      const allSetsData = await getQuestionSetsAll({
        id: groupId,
        limit: 5000,
      }).unwrap();

      const {
        activatedQuestions
      } = allSetsData.data;

      let newQuestionIds: string[];

      if (currentGroupStatus === 'ACTIVATED') {
        newQuestionIds = activatedQuestions
          .filter((aq) => aq.id !== questionSetId)
          .flatMap((aq) => aq.questions.map((q) => q.id));
      } else {
        const existingIds = activatedQuestions.flatMap((aq) => aq.questions.map((q) => q.id),);

        const setQuestionsData = await getQuestionsBySetIdAll({
          id: groupId,
          questionSetId,
          limit: 5000,
        }).unwrap();

        const setQuestionIds = setQuestionsData.data.questions.map((q) => q.id);

        newQuestionIds = Array.from(
          new Set([...existingIds, ...setQuestionIds]),
        );
      }

      const response = await postGroupQuestions({
        id: groupId,
        updateGroupQuestionsBodySchema: {
          questionIds: newQuestionIds,
        },
      }).unwrap();

      successfulToast(response.message);
    } catch (error) {
      showWarningFromServer(error);
      throw error;
    } finally {
      setLoadingSetId(null);
    }
  };

  return {
    toggle,
    loadingSetId,
  };
};
